<div class="container">
  <div class="row ">
    <div class=" col-lg-12">

      <h3>Energielieferverträge von {{currentUser?.person?.displayName}}</h3>
      <mat-card appearance="outlined" class="mat-card-warning" style="margin-bottom: 25px;">
        <mat-card-title>
          Energielieferverträge werden über die Synchronisierung aktualisiert.
        </mat-card-title>
        <mat-card-content>
          <span>
            Bearbeitung der Verträge führt nicht zur Aktualisierung in Ihrem ERP-System!
 
          </span>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row marginTop2Rem marginBottom2Rem">
    <div class=" col-lg-12">

      <mat-card appearance="outlined" class="mat-card-warning{" style="margin-bottom: 25px;">
        <mat-card-title>
          Vertrag verwalten
        </mat-card-title>
        <mat-card-content [formGroup]="editContractForm" id="formCard">
          <div class="row">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Status:</mat-label>
                <mat-select formControlName="contractType">
                  <mat-option *ngFor="let state of SupplyContractType" [value]="state.value">
                    {{state.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="editContractForm.get('contractType').hasError('required')">
                  Typ <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Status:</mat-label>
                <mat-select formControlName="contractState">
                  <mat-option *ngFor="let state of supplyContractState" [value]="state.value">
                    {{state.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="editContractForm.get('contractState').hasError('required')">
                  Typ <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Vertragsnr:</mat-label>
                <input matInput type="text" formControlName="number">
                <mat-error *ngIf="editContractForm.get('number').hasError('required')">
                  Vertragsnr <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Zählernr:</mat-label>
                <input matInput type="text" formControlName="measuringPointNumber">
                <mat-error *ngIf="editContractForm.get('measuringPointNumber').hasError('required')">
                  Zählernr <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Gültig von:</mat-label>
                <input matInput type="date" formControlName="validFrom">
                <mat-error *ngIf="editContractForm.get('validFrom').hasError('required')">
                  Gültig von <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Gültig bis:</mat-label>
                <input matInput type="date" formControlName="validUntil">
                <mat-error *ngIf="editContractForm.get('validUntil').hasError('required')">
                  Gültig bis <strong>muss</strong> angegeben werden
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <mat-checkbox formControlName="locallyManaged">
                Nicht ändern
              </mat-checkbox>

            </div>
          </div>


        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-button color="primary" (click)="edit()"
            [disabled]="this.editContractForm.invalid || this.editContractForm.touched == false">Änderungen
            speichern</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>

<div class="container" *ngIf="loading">
  <div class="row">
    <div class="col-sm-12 padding">
      <div class="loadingOverlay">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>